import { Platform } from '@angular/cdk/platform';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { environment } from 'environments/environment';
import * as CryptoJS from 'crypto-js';
import { el, th } from 'date-fns/locale';
import { httpHeader } from 'global/httpHeader';

@Component({
    selector: 'app-sidenav',
    templateUrl: './sidenav.template.html',
    standalone: false
})
export class SidenavComponent {
  @Input('items') public menuItems: any[] = [];
  @Input('hasIconMenu') public hasIconTypeMenuItem: boolean;
  @Input('iconMenuTitle') public iconTypeMenuTitle: string;
  @ViewChild('sidenav') sidenav: ElementRef;

  public baseUrl: string = environment.apiURL;
  public osVersion: string;
  public browserVersion: string;
  public v2Prefix = 'v2';
  constructor(
    private http: HttpClient,
    private platform: Platform,
  ) {}
  ngOnInit() {
    this.getOSVersion();
    this.getBrowserVersion();
    this.getMachineId();
  }

  // Only for demo purpose
  addMenuItem() {
    this.menuItems.push({
      name: 'ITEM',
      type: 'dropDown',
      tooltip: 'Item',
      icon: 'done',
      state: 'material',
      sub: [
        { name: 'SUBITEM', state: 'cards' },
        { name: 'SUBITEM', state: 'buttons' },
      ],
    });
  }

  Testmenulog(item) {
    // if(this.baseUrl != 'https://cf-v1.hanumanbeer.com.kh/dms/'){
    //   return
    // }else{
    let version: string = environment.appVersion;
    const os = window.navigator.userAgent;
    let body = {
      menuID: item.id,
      operatingSystem: this.osVersion + ', ' + this.browserVersion,
      appVersion: version,
      appName: environment.appName,
      deviceID: this.getMachineId(),
    };
    this.http
      .post(
        this.baseUrl + 'ActionLog/menu/creation',
        body,
        httpHeader.httpOptions,
      )
      .subscribe(
        (res) => {},
        (err) => {
          console.error(err);
        },
      );
    // }
  }
  getMachineId() {
    var navigatorInfo = navigator.userAgent;
    var pluginsLength = navigator.plugins.length;
    var mimeTypesLength = navigator.mimeTypes.length;

    // Concatenate relevant information to generate a unique machine ID
    var machineId = navigatorInfo + pluginsLength + mimeTypesLength;

    // Hash the concatenated string to create a unique identifier
    var hashedId = this.hashString(machineId);

    return hashedId;
  }

  hashString(str) {
    // Perform a hashing algorithm (e.g., MD5, SHA1, etc.) to create a hash of the string
    // Implement the hashing algorithm of your choice or use a third-party library

    // Example: using the MD5 hashing algorithm
    var md5Hash = CryptoJS.MD5(str).toString();

    return md5Hash;
  }
  getOSVersion() {
    const userAgent = window.navigator.userAgent;
    if (this.platform.isBrowser) {
      if (userAgent.indexOf('Win') !== -1) {
        // Windows
        const windowsVersion = this.getWindowsVersion(userAgent);
        this.osVersion = `Windows ${windowsVersion}`;
      } else if (userAgent.indexOf('Mac') !== -1) {
        // Mac
        this.osVersion = 'Mac OS';
      } else if (userAgent.indexOf('Linux') !== -1) {
        // Linux
        this.osVersion = 'Linux';
      } else {
        this.osVersion = 'Unknown';
      }
    }
  }
  getWindowsVersion(userAgent: string): string {
    // Parse the Windows version from the user agent string
    // You can customize this based on your requirements
    // Example: "Windows NT 10.0" -> "10.0"
    const match = /Windows NT (\d+\.\d+)/.exec(userAgent);
    return match ? match[1] : '';
  }

  getBrowserVersion() {
    if (this.platform.isBrowser) {
      const userAgent = window.navigator.userAgent;
      const matchChrome = /Chrome\/([0-9.]+)/.exec(userAgent);
      const matchFirefox = /Firefox\/([0-9.]+)/.exec(userAgent);
      const matchSafari = /Version\/([0-9.]+).*Safari/.exec(userAgent);
      const matchEdge = /Edg\/([0-9.]+)/.exec(userAgent);

      if (matchChrome) {
        this.browserVersion = `Chrome ${matchChrome[1]}`;
      } else if (matchFirefox) {
        this.browserVersion = `Firefox ${matchFirefox[1]}`;
      } else if (matchSafari) {
        this.browserVersion = `Safari ${matchSafari[1]}`;
      } else if (matchEdge) {
        this.browserVersion = `Edge ${matchEdge[1]}`;
      } else {
        this.browserVersion = 'Unknown';
      }
    }
  }

  render(url) {
    if (url.includes('#version2')) {
      return url.replace(/#version2/g, this.v2Prefix);
    }
  }
}
